import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {
  MODALS,
  fetchStaffMembers,
  fetchAllTeams,
  fetchMyTeams
} from 'ducks/teams';

import {InviteNewStaffMemberForm} from './components';

import './styles.css';

class InviteNewStaffMemberModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.submit('inviteNewStaffMember');
  };

  submitExtraActions = [
    ...this.props.closeModalExtraActions,
    fetchStaffMembers,
    fetchAllTeams,
    fetchMyTeams
  ];

  render() {
    const {closeModal, submitting} = this.props;

    return (
      <Modal
        className="InviteNewStaffMemberModal"
        type={Modal.EXTRA_SMALL}
        show={true}
        onClose={closeModal}>
        <Modal.Header heading="Invite New Staff Member to Team" />
        <Modal.Body>
          <InviteNewStaffMemberForm
            submitExtraActions={this.submitExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={closeModal}>
            Cancel
          </Button>
          <Button
            onClick={this.triggerFormSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  submitting: isSubmitting('inviteNewStaffMember')(state)
});
const mapDispatchToProps = {submit};

export default withModal(
  MODALS.INVITE_NEW_STAFF_MEMBER,
  mapStateToProps,
  mapDispatchToProps
)(InviteNewStaffMemberModal);
